/**
 * params: {
 *  noempty: 'Поле не должно быть пустым'
 * }
 */

const isEmptyString = (value) => !value;

const isNumber = (value) => !Number.isNaN(+value);

export const validate = (value, params) => {
    if ('noempty' in params) {
        if (isEmptyString(value)) {
            return params.noempty;
        }
    }

    if ('isnumber' in params) {
        if (!isNumber(value)) {
            return params.isnumber;
        }
    }

    return 'OK';
};
